import $ from 'jquery';

/**
 * If dropdown selection = "other", show the text box to enter more information
 */
class DropdownOtherInputs {
    constructor () {
        this.$otherSelect = $('.js-other-select select');

        this.$otherSelect.on('change', function () {
            DropdownOtherInputs.checkFields(this);
        });

        $(window).on('load', $.proxy(this.onLoad, this));
    }

    onLoad () {
        this.$otherSelect.each(function () {
            DropdownOtherInputs.checkFields(this);
        });
    }

    static checkFields (elem) {
        const selectedText     = $(elem).find("option:selected").text();
        const $otherInputField = $(elem).closest('.js-other-select').next('.js-other-field');

        if (selectedText.toLowerCase().indexOf('other') > -1) {
            $otherInputField.show();
        } else {
            $otherInputField.hide();
        }
    }
}

export default DropdownOtherInputs;
